(() => {
  const selector = '[data-nlp-reveal]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  const revealImmediately = (items) => {
    items.forEach((item) => item.classList.add('is-visible'));
  };

  const initReveal = (root = document) => {
    const items = [];

    if (root instanceof Element && root.matches(selector)) {
      items.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll(`${selector}:not(.is-visible)`).forEach((item) => items.push(item));
    }

    if (!items.length) return;

    // In Shopify's theme editor, sections and blocks are re-rendered dynamically.
    // They must remain visible immediately after a setting or product is changed.
    if (designMode || reducedMotion || !('IntersectionObserver' in window)) {
      revealImmediately(items);
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    items.forEach((item) => observer.observe(item));
  };

  const init = () => initReveal(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Shopify Theme Editor events fired after a section/block is replaced.
  document.addEventListener('shopify:section:load', (event) => initReveal(event.target));
  document.addEventListener('shopify:section:select', (event) => initReveal(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.shopify-section') || event.target;
    initReveal(section);
  });
})();
